// Scope the accepted Chancen scene, including explicit appointment/referral continuations.
export function isOpportunityScene(location) {
  return /^\/m\/opportunities(?:\/|$)/.test(location.pathname) ||
    (location.state?.opportunityDesign === true && ['/m/appointments', '/m/referrals'].includes(location.pathname));
}
